// components/Projects.jsx

import React, { useContext, useMemo } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import projectsData from '../data/javascripts/projectsData';
// Import the new ProjectCard widget
import ProjectCard from '../widgets/ProjectCard'; 
import ActionButton from '../widgets/ActionButton';

const Projects = () => {
    const { darkMode } = useContext(ThemeContext);

    const themeClasses = useMemo(() => ({
        // Outer wrapper for full-width background color and vertical padding
        sectionWrapper: 'bg-bg-light dark:bg-bg-dark py-20',
        
        // Content classes
        headingText: 'text-primary dark:text-secondary',
        
        // Main Action Button (consistent with your theme logic)
        mainButton: 'bg-primary dark:bg-secondary hover:bg-primary/90 dark:hover:bg-secondary/90 text-white font-semibold py-3 px-8 rounded-lg shadow-lg transition duration-300',
    }), []);

    return (
        // ⭐ FIX: Apply full background color and padding to an outer div
        <div className={themeClasses.sectionWrapper}> 
            <section id="projects" className="container mx-auto px-4">
                
                {/* Header */}
                <div className="text-center mb-12">
                    <h2 className={`text-4xl font-bold mb-2 ${themeClasses.headingText}`}>
                        Featured Projects
                    </h2>
                    <p className="text-lg text-text-light dark:text-text-dark opacity-80">
                        Explore technical deep dives and practical applications
                    </p>
                </div>

                {/* Projects Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {projectsData.map((project, index) => (
                        <div key={index} className="col">
                            {/* Use the new ProjectCard component */}
                            <ProjectCard project={project} darkMode={darkMode} />
                        </div>
                    ))}
                </div>


                <div className="text-center mt-12">
                    <ActionButton 
                        text="View All on GitHub" 
                        onClick={() => window.open('https://github.com/varunrao1991', '_blank')}
                        className="btn-md"
                    />
                </div>
            </section>
        </div>
    );
};

export default Projects;